module.exports = __webpack_public_path__ + "static/media/background-1.59eda8b4.svg";